import Avata from './avata';

export default Avata;
